import { Injectable } from "@angular/core";
import { DbTableDefinition } from "src/app/_services/persistence/db-persistence/db-table-definition";

@Injectable({
  providedIn: 'root'
})
export class MaterialDbTableDefinition extends DbTableDefinition {
    tableName = 'materials';
    tableStructure = `(id BIGINT(20) PRIMARY KEY null,
       label TEXT NOT NULL,
       databag LONGTEXT,
       unit TEXT,
       groupid TEXT,
       name TEXT,
       searchkey TEXT,
       extid TEXT,
       costcenter BIGINT(20),
       wtrelevant BOOLEAN
      );`;

      constructor() {
        super();
        // Add UpdateStatements to Map
      }
}